import {
  BLENDING_CHECK_ANSWER,
  BLENDING_CANCEL_RESPONSE,
  BLENDING_FINISHED,
  BLENDING_PLAY_AGAIN,
  BLENDING_SET_ORIGINAL_ALPHABET_LIST,
  BLENDING_RESET_ANSWERED,
  BLENDING_SET_IS_SINGLE_ROW,
} from "./../actions/actionIdentifiers";
import {
  BLENDING_IMPORT,
  BLENDING_SET_ROUND,
  BLENDING_RESET_ALPHABET_LIST,
  BLENDING_DRAG_CARD,
} from "../actions/actionIdentifiers";

export interface BlendingState {
  alphabets: string[] | string[][];
  words: {
    value: string;
    blanks: number[];
    unit_alphabets?: string[] | string[][];
    disable_shuffle?: boolean;
  }[];
  maxAlphabet: number;
  round: number;
  originalAlphabetList: string[] | string[][];
  alphabetList: string[] | string[][];
  answer: string | string[];
  blanks: number[];
  answered: string[];
  response: string;
  isFinished: boolean;
  disableShuffle: boolean;
  isSingleRow: boolean;
}

const initialState: BlendingState = {
  alphabets: [],
  words: [],
  maxAlphabet: null,
  round: null,
  originalAlphabetList: [],
  alphabetList: [],
  answer: null,
  blanks: [],
  answered: [],
  response: null,
  isFinished: false,
  disableShuffle: false,
  isSingleRow: true,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case BLENDING_IMPORT:
      return { ...state, ...payload };
    case BLENDING_SET_ROUND:
      return { ...state, ...payload };
    case BLENDING_SET_ORIGINAL_ALPHABET_LIST:
      return { ...state, originalAlphabetList: payload };
    case BLENDING_RESET_ALPHABET_LIST:
      return { ...state, alphabetList: payload };
    case BLENDING_RESET_ANSWERED:
      return { ...state, answered: payload };
    case BLENDING_DRAG_CARD:
      return { ...state, ...payload };
    case BLENDING_CHECK_ANSWER:
      return { ...state, response: payload };
    case BLENDING_CANCEL_RESPONSE:
      return { ...state, response: null };
    case BLENDING_FINISHED:
      return { ...state, isFinished: true };
    case BLENDING_PLAY_AGAIN:
      return { ...state, isFinished: false };
    case BLENDING_SET_IS_SINGLE_ROW:
      return { ...state, isSingleRow: payload };
    default:
      return state;
  }
};
